/* eslint-disable guard-for-in */
import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import { queryStubGroupList, prefixFile } from "@/fetch/fetchApi";
import RefreshGrid from "@/utils/refreshGrid";
import { useAuth, triggerDownloadFiles } from "@/utils/utils";
// 国际化切换语言
import { injectIntl } from "react-intl";

class MoveEquipment extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  componentWillMount() {
    this.queryStubId = "";
    if (window.LayoutTab && window.LayoutTab.tabParam) {
      this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
    }
    this.init();
  }

  init() {
    this.formConfig = {
      childItems: [
        {
          type: "input",
          placeholder: "请输入",
          param: {
            name: "stubId",
            type: "string",
          },
          labelName: "设备编号",
          required: false,
          defaultValue:
            !this.queryStubId || this.queryStubId == null || this.queryStubId == ""
              ? ""
              : this.queryStubId,
        },
        {
         type: "buttonGp", // 表单最终执行组
         buttonArr: [
           useAuth("010901")
             ? {
                 btnType: "submit",
                 text: "查询",
               }
             : "",
           useAuth("010902")
             ? {
               btnType: "button",
               text: '导出',
               handler: (e, param) => {
                 this.exportData(param);
               },
               }
             : "",
         ],
       },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "submit", // 表单提交类型，设置grid则为更新grid
      defaultParams: {
        stubId: this.queryStubId,
      },
      context: this,
      autoLoadGrid: !0, // 设置为false不触发加载grid
      tableKey: "moveEquipmentTable",
    };

    this.setState({
      tableConfig: {
        tableColumns: [
          {
             name: "设备编号",
             key: "stubId",
             colType: "textCol",
             align: "left",
             width: 150,
           },
          {
             name: "电站名称",
             key: "stubGroupName",
             colType: "textCol",
             align: "left",
             width: 150,
          },
          {
             name: "电站状态",
             key: "statusCn",
             colType: "textCol",
             align: "left",
             width: 100,
           },
           {
             name: "启用时间",
             key: "activationTime",
             colType: "textCol",
             align: "left",
             width: 100,
           },
          {
              name: '首次上线时间',
              key: "firstOnlineTime",
              colType: "textCol",
              align: "left",
              width: 100,
            },
            {
              name: "下线日期",
              key: "shutdownDay",
              colType: "textCol",
              align: "left",
              width: 100,
            },   
            {
              name: "首次平台订单号", 
              key: "firstOrderId",
              colType: "textCol",
              align: "left",
            },
            {
              name: "首次启动充电时间",
              key: "firstChargingTime",
              colType: "textCol",
              align: "left",
              width: 100,
            },
            {
             name: "末次平台订单号", 
             key: "lastOrderId",
             colType: "textCol",
             align: "left",
             width: 100,
           },
           {
             name: "末次启动充电时间",
             key: "lastChargingTime",
             colType: "textCol",
             align: "left",
             width: 100,
           },
        ],
        tableChange: () => {},
        tableParam: {
          stubId: this.queryStubId,
        },
        dataApi: queryStubGroupList,
        tableKey: "moveEquipmentTable",
        autoRefresh: !0, // 设置为true 直接加载grid数据
      },
    });
  }

  // 数据导出
  exportData = (param) => {
    
    const excelUrl = `${prefixFile}/mtsV2/shutDown/shutdown/stubGroup/export`;

    param.locale = this.props.intl.locale;

    var params = "";
    Object.keys(param).forEach((key) => {
      if (param[key] !== undefined) {
        params += `${key}=${param[key]}&`;
      }
    });
    const ele = document.createElement("a");
    ele.download = encodeURI(`${excelUrl}?${params}`);
    ele.style.display = "none";
    ele.href = encodeURI(`${excelUrl}?${params}`);
    ele.target = "_blank"; // 针对 ie模式 的浏览器
    // 触发点击
    document.body.appendChild(ele);
    ele.click();
    // 然后移除
    document.body.removeChild(ele);
  };

  // 数据导出
  async exportData(param) {
    console.log('1111111', param)
    await triggerDownloadFiles(
      "/mtsV2/shutDown/shutdown/stubGroup/export",
      {
        ...param,
      },
      "挪桩设备记录",
      "xlsx",
      "post",
    );
  }
  /**
   * 表格数据加载方法
   */
  fetchApi = (param) => {
    console.log("请求参数：", param);
    // 如果正常页面中的表单提交，请执行下面
    return RefreshGrid(this.context.store, "moveEquipmentTable", param);
  };

  render() {
    const Content = (
      <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel overScroll">
          <ScGridTable config={this.state.tableConfig} unTotalMode />
        </div>
      </div>
    );

    return Content;
  }
}

export default injectIntl(MoveEquipment);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/moveEquipmentList.js